import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import rootSaga from './state/saga';
import reducer from './state';

function createReduxStore() {
  const sagaMiddleware = createSagaMiddleware();

  const middlewares = [routerMiddleware(browserHistory), sagaMiddleware, thunk];

  const sentryReduxEnhancer = Sentry.createReduxEnhancer();

  const composeEnhancers = composeWithDevTools({
    serialize: {
      options: {
        error: true,
      },
    },
  });
  const store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)
  );

  // Kickoff sagas
  sagaMiddleware.run(rootSaga);
  return store;
}

export default createReduxStore;
